import { render } from "./FirmwareDetails.vue?vue&type=template&id=58d616f5&ts=true"
import script from "./FirmwareDetails.vue?vue&type=script&lang=ts"
export * from "./FirmwareDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__